async function createAgeChart() {
	const URL='http://54.152.206.84:8000/';
	let response = await fetch(URL + 'list/virus/')
	let data = await response.json();

	
	let myAges = [], myIds = [];

	//iterate through data
	for (line in data) {

		//there can be multiple entries per patient id, so only push if it is a new id
		let myId = data[line].ptid;
		
		if (myIds.indexOf(myId) == -1) {
			myAges.push(data[line].age)
			myIds.push(myId)
		}
	}
	
	var { child, teen, adult} = countAges(myAges)

	let chartStatus = Chart.getChart("agechart");
	if (chartStatus != undefined) {
		chartStatus.destroy()
	} //end of destroying chart

	let ctx = document.getElementById("agechart").getContext('2d');
	window.myChart = new Chart(ctx, {
        	type: "pie",
                data: {
			labels: ['Child(0-10)', 'Teenager(14-18)', 'Adult(20-64)'],
			datasets: [{ backgroundColor: ['blue', 'green', 'red'], data: [ child, teen, adult] }]
		}, options: { responsive: true,
                                        plugins: {
						title: { display: true, 
							text: "Ages of Participants",
							font: { size: 20, weight: 'bold' } } } } }); //end of chart

	}


function countAges(myAges) {
	//there are 3 cohorts, sort the numbers
	let child = 0; teen = 0; adult = 0; 

	//sort into child, teenager, adult
	for (i in myAges) {

		if (myAges[i] <= 10) {child = child + 1}	
		else if (myAges[i] > 14 & myAges[i] < 20) {teen = teen + 1}
		else if (myAges[i] < 65) {adult = adult + 1}
	}

	return { child, teen, adult }
}
